module.exports = __webpack_public_path__ + "static/img/183_TO8_2037_og.43a64b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/183_TO8_2037_og.jpg
// module id = 1VFw
// module chunks = 0